import { render, staticRenderFns } from "./inputItem.vue?vue&type=template&id=6873ca55&scoped=true"
import script from "./inputItem.vue?vue&type=script&lang=js"
export * from "./inputItem.vue?vue&type=script&lang=js"
import style0 from "./inputItem.vue?vue&type=style&index=0&id=6873ca55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6873ca55",
  null
  
)

export default component.exports